import moment from 'moment';

// eslint-disable-next-line import/prefer-default-export
export const getToday = timezone => moment.tz(timezone).startOf('day').utc().toDate();
